import { customFetch } from '@/lib/utils';

import type { TeamConversation, TeamConversationShare } from './types';

type AuthenticatedRequest = { accessToken: string };

async function parseResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: string } | null;
    throw new Error(body?.error || `Request failed with status ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function getConversationTeamShares({
  accessToken,
  conversationId
}: AuthenticatedRequest & { conversationId: string }) {
  const response = await customFetch(`/backend/conversations/${conversationId}/teams`, {
    headers: { Authorization: `Bearer ${accessToken}` }
  });
  return parseResponse<TeamConversationShare[]>(response);
}

export async function setConversationTeamShare({
  accessToken,
  conversationId,
  share,
  teamId
}: AuthenticatedRequest & {
  conversationId: string;
  share: boolean;
  teamId: string;
}) {
  const response = await customFetch(`/backend/conversations/${conversationId}/teams`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ team_id: teamId, share })
  });
  return parseResponse<TeamConversationShare | { success: true }>(response);
}

export async function getTeamConversations({
  accessToken,
  teamId
}: AuthenticatedRequest & { teamId: string }) {
  const response = await customFetch(`/backend/teams/${teamId}/conversations`, {
    headers: { Authorization: `Bearer ${accessToken}` }
  });
  return parseResponse<TeamConversation[]>(response);
}
